module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('MapView', {
    ref: "leaflet"
  }), _vm._v(" "), _c('DataForm', {
    ref: "form",
    on: {
      "input": _vm.setData
    }
  }), _vm._v(" "), _c('timestamp', {
    ref: "time",
    attrs: {
      "date": _vm.date,
      "time": _vm.time
    },
    on: {
      "skipfwd": _vm.skipfwd,
      "skipback": _vm.skipback,
      "pause": _vm.pause,
      "play": _vm.play
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-115c0d71","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 235
// module chunks = 1